<template>
  <div>
    <el-container>
      <el-drawer :with-header="false" direction="ltr" :append-to-body="true" :visible.sync="drawer" size="260px">
        <!-- <el-aside
          id="elaside"
          :width="asideWidth"
          :style="{
            backgroundColor: color,
          }"
        > -->
        <el-menu id="elaside" :router="false" :default-openeds="openeds" :collapse="isCollapse"
          :collapse-transition="false" style="min-height: 100vh; max-height: 100vh; overflow-y: scroll"
          :background-color="color" :text-color="color1" :active-text-color="color2" @open="handleOpen"
          @close="handleClose">
          <div class="text-center mt-3 mb-1">
            <a v-if="searchbar" @click="setRoute('admin')" style="cursor: pointer">
              <img src="../../../static/img/logo/Logo2.jpeg" width="60" height="60" alt="" />
            </a>
          </div>
          <!-- <div class="searchbar" v-if="searchbar">
            <div class="field-input ml-2">
              <input type="text" placeholder="Search" /><span> </span>
            </div>
          </div> -->
          <el-menu-item v-if="permissions.includes('dashboard')" @click="setRoute('dashboard')" index="dashboard">
            <i class="el-icon-menu"></i>
            <span slot="title">Dashboard</span>
          </el-menu-item>

          <el-menu-item v-if="permissions.includes('analytics')" @click="setRoute('analytics')" index="Footers">
            <i class="el-icon-data-analysis"></i>
            <span slot="title">Analytics</span>
          </el-menu-item>

          <el-menu-item v-if="permissions.includes('categories')" @click="setRoute('managecategories')" index="Form">
            <i class="el-icon-collection-tag"></i>
            <span slot="title">Categories</span>
          </el-menu-item>

          <el-submenu index="6" v-if="permissions.includes('products')">
            <!-- v-if="plan != 'Starter' && (sysadmin || manager)"  previous condition-->
            <template slot="title">
              <i class="el-icon-goods"></i>
              <span slot="title">Products</span>
            </template>
            <template v-for="(value, key) in Object.keys($store.state.categories).sort()">
              <!-- new common prd create routing -->
              <el-menu-item :key="key" @click="setRoute('categories', 'cat', value)" :index="`6-${key}`"><i
                  class="el-icon-discount"></i> {{ value }}</el-menu-item>
              <!-- previous shop category based create form routing -->
              <!-- <el-menu-item
                v-if="
                  key != 'Mobiles' &&
                  key != 'Tablets' &&
                  key != 'Desktops' &&
                  key != 'Laptops' &&
                  shopcategory == ''
                "
                :key="key"
                @click="setRoute('categories', 'cat', key)"
                :index="`6-${key}`"
                ><i class="el-icon-discount"></i> {{ key }}</el-menu-item
              >
              <el-menu-item
                v-if="
                  key == 'Mobiles' ||
                  key == 'Tablets' ||
                  key == 'Desktops' ||
                  key == 'Laptops'
                "
                :key="key"
                @click="setRoute('mobiles', 'cat', key)"
                :index="`6-${key}`"
                ><i class="el-icon-discount"></i> {{ key }}</el-menu-item
              >
              <el-menu-item
                v-if="shopcategory == 'Vehicles'"
                :key="key"
                @click="setRoute('vehicles', 'cat', key)"
                :index="`6-${key}`"
                ><i class="el-icon-discount"></i> {{ key }}</el-menu-item
              > -->
            </template>
          </el-submenu>

          <el-menu-item v-if="permissions.includes('products')" @click="setRoute('stockSummary')" index="stockSummary">
            <i class="el-icon-s-claim"></i>
            <span slot="title">Stock Summary</span>
          </el-menu-item>

          <el-submenu index="7" v-if="
            permissions.includes('invoice write') ||
            permissions.includes('invoice list') ||
            permissions.includes('invoice return')
          ">
            <template slot="title">
              <i class="el-icon-document-copy"></i>
              <span slot="title">Invoice</span>
            </template>
            <!-- <el-menu-item-group>
                        <span slot="title">Group One</span> -->
            <el-menu-item v-if="permissions.includes('invoice write')" @click="setRoute('createinvoice')" index="7-1">
              <i class="el-icon-document-add"></i>
              Create Invoice</el-menu-item>
            <el-menu-item v-if="permissions.includes('invoice list')" @click="setRoute('invoicelist')" index="7-2"><i
                class="el-icon-document"></i>Invoice List</el-menu-item>
            <el-menu-item v-if="permissions.includes('invoice return')" @click="setRoute('returns')" index="7-3"><i
                class="el-icon-bottom"></i>Returns</el-menu-item>
            <!-- <el-menu-item @click="setRoute('createbarcode')" index="7-4"
              >Create Barcodes</el-menu-item
            > -->
            <!-- </el-menu-item-group> -->
            <!-- <el-menu-item-group title="Group Two">
                        <el-menu-item index="6-4" >item one</el-menu-item>
                        <el-menu-item index="6-5">item two</el-menu-item>
                        <el-menu-item index="6-6">item three</el-menu-item>
                    </el-menu-item-group> -->
          </el-submenu>

          <el-menu-item v-if="shopcategory === 'Food / Restaurants'" @click="setRoute('kot')" index="kot">
            <i class="el-icon-tableware"></i>
            <span slot="title">KOT</span>
          </el-menu-item>

          <el-menu-item v-if="shopcategory == 'Mobiles & Tablets' || shopcategory == 'Computers'" @click="setRoute('jobNotes')" index="jobs">
            <i class="el-icon-cpu"></i>
            <span slot="title">Job Notes</span>
          </el-menu-item>

          <el-menu-item v-if="shopcategory" @click="setRoute('orderProcessing')" index="orderProcessing">
            <i class="el-icon-refresh"></i>
            <span slot="title">Order Processing</span>
          </el-menu-item>

          <el-submenu index="8" v-if="
            permissions.includes('GRN list') ||
            permissions.includes('GRN write') ||
            permissions.includes('GRN return')
          ">
            <template slot="title">
              <i class="el-icon-truck"></i>
              <span slot="title">Purchasing</span>
            </template>
            <el-menu-item v-if="permissions.includes('GRN list')" @click="setRoute('purchase-order-list')"
              index="purchase-order-list">
              <i class="el-icon-truck"></i>
              <span slot="title">GRN List</span>
            </el-menu-item>
            <el-menu-item v-if="permissions.includes('GRN write')" @click="setRoute('create-purchase-order')"
              index="create-purchase-order">
              <i class="el-icon-truck"></i>
              <span slot="title">Create GRN</span>
            </el-menu-item>
            <el-menu-item v-if="permissions.includes('GRN return')" @click="setRoute('purchase-order-returns')"
              index="8-3"><i class="el-icon-bottom"></i>Returns</el-menu-item>
          </el-submenu>

          <el-submenu index="9" v-if="permissions.includes('expenses')">
            <template slot="title">
              <i class="el-icon-wallet"></i>
              <span slot="title">Expenses</span>
            </template>
            <el-menu-item @click="setRoute('expenses')" index="expenses">
              <i class="el-icon-wallet"></i>
              <span slot="title">Manage Expenses</span>
            </el-menu-item>
            <el-menu-item @click="setRoute('expense-categories')" index="expense-categories">
              <i class="el-icon-collection-tag"></i>
              <span slot="title">Expense Categories</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item v-if="permissions.includes('cash flow')" @click="setRoute('cash-flow-history')"
            index="cash-flow-history">
            <i class="el-icon-money"></i>
            <span slot="title">Cash Flow</span>
          </el-menu-item>

          <el-submenu index="10" v-if="
            permissions.includes('quotation list') ||
            permissions.includes('quotation write')
          ">
            <template slot="title">
              <i class="el-icon-edit-outline"></i>
              <span slot="title">Quotations</span>
            </template>
            <el-menu-item v-if="permissions.includes('quotation list')" @click="setRoute('quotation-list')"
              index="quotation-list">
              <i class="el-icon-edit-outline"></i>
              <span slot="title">Quotations List</span>
            </el-menu-item>

            <el-menu-item v-if="permissions.includes('quotation write')" @click="setRoute('create-quotation')"
              index="create-quotation">
              <i class="el-icon-edit-outline"></i>
              <span slot="title">Create Quotation</span>
            </el-menu-item>
          </el-submenu>

          <!-- <el-submenu index="11" v-if="
            permissions.includes('quotation list') ||
            permissions.includes('quotation write')
          ">
            <template slot="title">
              <i class="el-icon-edit-outline"></i>
              <span slot="title">KOT</span>
            </template>
            <el-menu-item v-if="permissions.includes('quotation list')" @click="setRoute('kot')"
              index="kot">
              <i class="el-icon-edit-outline"></i>
              <span slot="title">Create KOT</span>
            </el-menu-item>

            <el-menu-item v-if="permissions.includes('quotation write')" @click="setRoute('kot-list')"
              index="kot-list">
              <i class="el-icon-edit-outline"></i>
              <span slot="title">KOT List</span>
            </el-menu-item>
          </el-submenu> -->

          <el-menu-item v-if="permissions.includes('customers')" @click="setRoute('customers')" index="customers">
            <i class="el-icon-s-custom"></i>
            <span slot="title">Customers</span>
          </el-menu-item>

          <el-menu-item v-if="permissions.includes('suppliers')" @click="setRoute('suppliers')" index="suppliers">
            <i class="el-icon-office-building"></i>
            <span slot="title">Suppliers</span>
          </el-menu-item>

          <el-submenu index="5" v-if="permissions.includes('online store')">
            <template slot="title">
              <i class="el-icon-shopping-cart-2"></i>
              <span slot="title">Online Store</span>
            </template>

            <el-menu-item @click="setRoute('admincontact')" index="admincontact">
              <i class="el-icon-phone-outline"></i>
              <span slot="title">Contact Page</span>
            </el-menu-item>
            <el-menu-item @click="setRoute('adminhome')" index="adminhome">
              <i class="el-icon-s-home"></i>
              <span slot="title">Home Page</span>
            </el-menu-item>
            <el-menu-item @click="setRoute('admingallery')" index="admingallery">
              <i class="el-icon-picture"></i>
              <span slot="title">Gallery</span>
            </el-menu-item>
            <el-menu-item @click="setRoute('offers')" index="offers">
              <i class="el-icon-shopping-cart-full"></i>
              <span slot="title">Offers</span>
            </el-menu-item>
            <el-menu-item @click="setRoute('orders')" index="orders">
              <!-- v-if="plan == 'Premium' || plan == 'Enterprise'" previous condition-->
              <i class="el-icon-truck"></i>
              <span slot="title">Orders</span>
            </el-menu-item>
            <el-menu-item @click="setRoute('storehome', 'storename', storeid)" index="storehome">
              <i class="el-icon-s-shop"></i>
              <span slot="title">View Store</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item v-if="permissions.includes('users')" @click="setRoute('users')" index="users">
            <i class="el-icon-user"></i>
            <span slot="title">Users</span>
          </el-menu-item>
          <el-menu-item v-if="permissions.includes('stores')" @click="setRoute('storelocations')"
            index="storelocations">
            <i class="el-icon-s-shop"></i>
            <span slot="title">Stores</span>
          </el-menu-item>
          <!-- <el-menu-item v-if="permissions.includes('stores')" @click="setRoute('create-labels')"
            index="create-labels">
            <i class="el-icon-s-shop"></i>
            <span slot="title">Create Labels</span>
          </el-menu-item> -->
          <el-menu-item v-if="permissions.includes('settings')" @click="setRoute('setting')" index="setting">
            <i class="el-icon-setting"></i>
            <span slot="title">Setting</span>
          </el-menu-item>
        </el-menu>
        <!-- </el-aside> -->
      </el-drawer>
      <el-container :style="{ marginLeft: elMainMargin }" style="background-color: rgb(246, 247, 248)">
        <el-header class="el-header" style="font-size: 24px"
          :style="{ width: elHheaderWidth, backgroundColor: color3 }">
          <i :class="menuicon" @click="drawer = true" style="
              text-align: right;
              margin-right: 15px;
              margin-top: 16px;
              cursor: pointer;
              font-size: 25px;
            "></i>

          <el-dropdown @command="handleCommand" trigger="click" style="float: right; font-size: 20px">
            <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
              style="cursor: pointer; margin-top: 10px"></el-avatar>
            <el-dropdown-menu slot="dropdown">
              <a @click="setRoute('dashboard')" v-if="permissions.includes('dashboard')">
                <el-dropdown-item><i class="el-icon-menu mr-2"></i>Dashboard
                  <!-- <span class="ml-5">16</span> -->
                </el-dropdown-item>
              </a>

              <a @click="setRoute('createinvoice')" v-if="permissions.includes('invoice write')">
                <el-dropdown-item><i class="el-icon-document-add mr-2"></i>Create
                  Invoice</el-dropdown-item>
              </a>

              <a @click="setRoute('storehome', 'storename', storeid)">
                <el-dropdown-item><i class="el-icon-s-shop mr-2"></i>View
                  Store</el-dropdown-item>
              </a>
              <a @click="setRoute('setting')" v-if="permissions.includes('settings')">
                <el-dropdown-item><i class="el-icon-setting mr-2"></i>Setting</el-dropdown-item>
              </a>

              <a @click="logout">
                <el-dropdown-item divided command="logout"><i class="el-icon-switch-button mr-2"></i>Log
                  out</el-dropdown-item>
              </a>
               <a href="tel:+94719500600" style="text-decoration: none;">
                <el-dropdown-item divided ><i class="el-icon-phone mr-2"></i>+94 719 500 600</el-dropdown-item>
              </a>
            </el-dropdown-menu>
          </el-dropdown>

          <el-select :disabled="disableSelect" @change="changeStore(store)"
            style="float: right; width: 160px !important; margin-right: 80px" size="small" label="Select Store"
            v-model="store" placeholder="Select Store">
            <el-option v-for="item in stores" :key="item.value" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
          <!-- <el-dropdown trigger="click" style="float: right; font-size: 22px">
            <i
              class="el-icon-message text-white"
              style="cursor: pointer; color: #eee"
            >
              <el-badge :value="3" class="item"></el-badge>
            </i>
            <el-dropdown-menu
              slot="dropdown"
              style="padding: 0px; background-color: #fffbfb"
            >
              <div class="header-notification">
                <div class="bell-icon small-icon">
                  <ul class="notification-list dropdown hide">
                    <li class="list-item">
                      <a href="#" class="list-item--link">
                        <img
                          src="https://cdn.tutsplus.com/net/uploads/legacy/213_chris/ChrisThumbnail.jpg"
                          alt=""
                          class="user-image"
                        />
                        <span class="messages">
                          <b>Ross Gellar </b> posted a photo on your wall.
                        </span>
                      </a>
                    </li>
                    <li class="list-item">
                      <a href="#" class="list-item--link">
                        <img
                          src="https://cdn.tutsplus.com/net/uploads/legacy/213_chris/ChrisThumbnail.jpg"
                          alt=""
                          class="user-image"
                        />
                        <span class="messages">
                          <b>Rachel Greene </b> posted 2 comments on your photo.
                        </span>
                      </a>
                    </li>
                    <li class="list-item">
                      <a href="#" class="list-item--link">
                        <img
                          src="https://cdn.tutsplus.com/net/uploads/legacy/213_chris/ChrisThumbnail.jpg"
                          alt=""
                          class="user-image"
                        />
                        <span class="messages">
                          <b>Joey Tribiani </b> commented on your last video.
                        </span>
                      </a>
                    </li>
                    <li class="list-item">
                      <a href="#" class="list-item--link">
                        <span class="messages">
                          <b>View all Notifications</b>
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <i
            class="el-icon-setting"
            @click="drawer = true"
            style="
              float: right;
              margin-right: 15px;
              margin-top: 18px;
              cursor: pointer;
              font-size: 22px;
            "
          ></i> -->
          <el-drawer title="" :append-to-body="true" size="340px">
            <div>
              <h6 class="text-center">Sidemenu Color</h6>
              <div class="text-center">
                <el-color-picker v-model="color" show-alpha :predefine="predefineColors"
                  size="medium"></el-color-picker>
              </div>
              <h6 class="text-center">Sidemenu Text Color</h6>
              <div class="text-center">
                <el-color-picker v-model="color1" show-alpha :predefine="predefineColors"
                  size="medium"></el-color-picker>
              </div>
              <h6 class="text-center">Sidemenu Active Color</h6>
              <div class="text-center">
                <el-color-picker v-model="color2" show-alpha :predefine="predefineColors"
                  size="medium"></el-color-picker>
              </div>
              <h6 class="text-center">Header Color</h6>
              <div class="text-center">
                <el-color-picker v-model="color3" show-alpha :predefine="predefineColors"
                  size="medium"></el-color-picker>
              </div>
              <h6 class="text-center">Footer Color</h6>
              <div class="text-center">
                <el-color-picker v-model="color4" show-alpha :predefine="predefineColors"
                  size="medium"></el-color-picker>
              </div>
            </div>
          </el-drawer>
        </el-header>

        <el-main v-if="show2" style="margin-top: 60px; margin-bottom: 100px">
          <!-- <div
            style="
              border: 1px solid #e2e2e2;
              padding: 20px;
              background-color: #f9f9f9;
              margin: -20px -20px 0 -20px;
            "
          >
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/admin' }"
                >Dashboard</el-breadcrumb-item
              >
              <el-breadcrumb-item
                v-if="
                  this.$route.name != 'admin' && this.$route.name != 'dashboard'
                "
              >
                {{ this.$route.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div> -->
          <Dashboard v-if="show" />
          <router-view :key="$route.fullPath" style="min-height: 85vh"></router-view>
        </el-main>

        <el-footer :style="{ backgroundColor: color4 }" v-if="showfooter">
          <p class="text-white mt-2 py-2" style="width: 100%">
            Eshops.lk &copy; {{ new Date().getFullYear() }} All rights reserved.
          </p>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import firebase from "firebase/app";
import db from "../../config/FirebaseInit";
import Dashboard from "./Dashboard";
import { bus } from "../../main";
import sizeof from "firestore-size";

export default {
  name: "admin",
  components: {
    Dashboard,
  },
  data() {
    return {
      store: "",
      disableSelect: false,
      stores: [],
      show: true,
      show2: false,
      toggleCat: false,
      isLoggedIn: false,
      currentUser: false,
      categoriesList: [],
      subcategories: [],
      category: "",
      subcategory: "",
      shops: [],
      secondaryDBshop: [],
      notices: [],
      storeid: "",
      shopcats: {},
      title: "",
      msg: "",
      modalShow1: false,
      showLSB: true,
      enlarged: "",
      plan: "",
      shopcategory: "",
      loading: false,
      fetch: true,
      isOnline: navigator.onLine,
      permissions: [],

      openeds: [],
      isCollapse: false,
      //   display: "block",
      //   visibility: "visible",
      showfooter: true,
      asideWidth: "0px",
      elMainMargin: "0px",
      elHheaderWidth: "calc(100% - 0px)",
      menuicon: "el-icon-s-unfold",
      show: false,
      searchbar: true,
      color: "#051e34",
      color1: "#fff",
      color2: "#BF88F7",
      color3: "#062845",
      color4: "#111",
      drawer: false,
      sysadmin: false,
      cashier: false,
      manager: false,
      predefineColors: [
        "#303133",
        "#909399",
        "#E4E7ED",
        "#F2F6FC",
        "#409EFF",
        "#E6A23C",
        "rgba(255, 69, 0, 0.68)",
        "hsva(120, 40, 94, 0.5)",
        "hsla(209, 100%, 56%, 0.73)",
        "#F56C6C",
      ],
    };
  },

  watch: {
    isOnline() {
      if (!navigator.onLine) {
        this.isOnline = false;
        this.$notify({
          title: "You are Offline",
          message: "Creating new records may cause inaccurate report data",
          duration: 0,
          showClose: false,
          position: "bottom-right",
          type: "warning",
        });
        // const offlineData = JSON.parse(localStorage.getItem("offlineData"));
        // if (!offlineData)
        localStorage.setItem("offlineData", JSON.stringify([]));
      } else if (navigator.onLine) {
        this.isOnline = true;
        this.$notify.closeAll();
        this.$notify({
          title: "You are Online ",
          message: "You are online now",
          type: "success",
        });
        const offlineData = JSON.parse(localStorage.getItem("offlineData"));
        console.log("offlineData", offlineData);
        setTimeout(async () => {
          const offlineData = JSON.parse(localStorage.getItem("offlineData"));
          const length = offlineData.length;
          console.log("offlineData outside", offlineData);
          for (let i = 0; i < length; i++) {
            console.log("offlineData", offlineData, "i = ", i);
            const item = offlineData[i];
            await this.$store.state.secondaryDatabase
              .collection(item.collection)
              .doc(item.id)
              .update(item.data);
            console.log("offlineData[i] is", offlineData[i]);
            // offlineData.shift();
            // localStorage.setItem("offlineData", JSON.stringify(offlineData));
            // .then((doc) => {
            //   console.log("doc is", doc);
            //   offlineData.shift();
            //   localStorage.setItem(
            //     "offlineData",
            //     JSON.stringify(offlineData)
            //   );
            // })
            // .catch((error) => alert(error));
          }
          //
        }, 4500);
      }
    },
    $route() {
      if (
        this.$route.fullPath == "/admin/" ||
        this.$route.fullPath == "/admin"
      ) {
        this.show = true;
        this.disableSelect = false;
      } else {
        this.show = false;
        if (
          this.$route.name === "create-purchase-order" ||
          this.$route.name === "createinvoice"
        ) {
          this.disableSelect = true;
        } else {
          this.disableSelect = false;
        }
      }
    },
  },

  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.isOnline = type === "online";
    },
    changeStore(store) {
      this.$root.$emit("storeChange", store);
      this.$store.state.selectedStore = store;
    },
    setRoute(index, param, key) {
      if (!key) this.$router.push({ name: index });
      if (key) this.$router.push({ name: index, params: { [param]: key } });
      this.drawer = false;
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      }
    },
    changeCollapse() {
      if (this.isCollapse == true) {
        this.isCollapse = false;
        this.searchbar = true;
        this.menuicon = "el-icon-s-fold";
        this.asideWidth = "260px";
        this.elMainMargin = "260px";
        this.elHheaderWidth = "calc(100% - 260px)";
      } else {
        this.isCollapse = true;
        this.searchbar = false;
        this.menuicon = "el-icon-s-unfold";
        if (screen.width > 550) {
          this.asideWidth = "80px";
          this.elMainMargin = "80px";
          this.elHheaderWidth = "calc(100% - 80px)";
        } else {
          this.asideWidth = "0px";
          this.elMainMargin = "0px";
          this.elHheaderWidth = "calc(100% - 0px)";
        }
      }
    },
    logout() {
      if (firebase.auth().currentUser) {
        if (this.cashier) {
          this.$router.go(0);
        } else {
          firebase
            .auth()
            .signOut()
            .then(() => {
              this.$router.push("/");
            });
        }
      }
    },
  },
  mounted() {
    if (!this.isOnline) {
      this.$notify({
        title: "You are Offline",
        message: "Creating new records may cause inaccurate report data",
        duration: 0,
        showClose: false,
        position: "bottom-right",
        type: "warning",
      });
    }
    if (this.$route.fullPath == "/admin/" || this.$route.fullPath == "/admin") {
      this.show = true;
    }
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  created() {
    this.loading = true;
    this.fetch = false;
    if (screen.width < 550) {
      //   this.display = "none";
      //   this.isCollapse = true;
      //   this.visibility = "hidden";
      this.showfooter = false;
    }
    if (this.$route.fullPath == "/admin/" || this.$route.fullPath == "/admin") {
      this.show = false;
    }

    bus.$on("userChanged", (data) => {
      // console.log(data);
      if (data.role === "Admin") this.sysadmin = true;
      if (data.role === "Cashier") this.cashier = true;
      if (data.role === "Shop Manager") this.manager = true;
      this.permissions = data.permissions || [];

      if (!this.sysadmin) {
        this.stores = this.stores.filter((store) => {
          if (this.$store.state.systemUser.stores.includes(store.id))
            return store;
        });
      }
      console.log(
        "userChanged",
        this.stores,
        this.$store.state.systemUser.stores,
        this.sysadmin,
        this.cashier,
        this.manager
      );
      this.$store.state.stores = this.stores;
      this.store = this.stores[0].id;
      this.$store.state.selectedStore = this.store;
    });
    if (this.$store.state.systemUser.role === "Admin") this.sysadmin = true;
    if (this.$store.state.systemUser.role === "Cashier") this.cashier = true;
    if (this.$store.state.systemUser.role === "Shop Manager")
      this.manager = true;
    if (this.$store.state.systemUser.permissions)
      this.permissions = this.$store.state.systemUser.permissions;

    if (firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
      this.storeid = firebase.auth().currentUser.uid;
      //console.log(firebase.auth().currentUser.uid)

      try {
        firebase.app(firebase.auth().currentUser.uid);
        this.$store.state.secondaryDatabase = firebase
          .app(firebase.auth().currentUser.uid)
          .firestore();
        this.show2 = true;
        //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
      } catch (err) {
        db.collection("shops")
          .where("owner", "==", firebase.auth().currentUser.uid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = {
                id: doc.id,
                shoptype: doc.data().shoptype,
                categories: doc.data().categories,
                name: doc.data().name,
                plan: doc.data().plan,
                shopcat: doc.data().cat,
                config: doc.data().config,
                email: doc.data().regemail,
                noDB: doc.data().noDB
              };
              this.shops.push(data);
            });
          })
          .then(() => {
            this.$store.state.plan = this.shops[0].plan;
            //console.log('this.shops[0].config', this.shops[0].config)
            if (!this.shops[0].noDB) { // having own db
              if (this.shops[0].config) {
                // console.log("config", this.shops[0].config);
                var secondaryAppConfig = this.shops[0].config;
                var secondary = firebase.initializeApp(
                  secondaryAppConfig,
                  firebase.auth().currentUser.uid
                );
                this.$store.state.secondaryDatabase = secondary.firestore();
                // this.$store.state.secondaryApp = this.$route.params.storename
                this.$store.state.secondaryDatabase.settings({
                  timestampsInSnapshots: true,
                });
                this.$store.state.secondaryDatabase
                  .enablePersistence({ synchronizeTabs: true })
                  .then(() => {
                    //console.log("Woohoo! Multi-Tab Persistence!");
                  });
                if (secondaryAppConfig.apiKey) {
                  firebase.auth(secondary).signInWithEmailAndPassword(this.shops[0].email, firebase.auth().currentUser.uid)
                  .then(user => {})
                  .catch(err => alert(err))
                }

                this.show2 = true;
              }
              //console.log('secondaryDB', this.$store.state.secondaryDatabase)
            } else {
              //console.log('shop config', this.shops[0].config)
              this.$store.state.secondaryDatabase = db;
              this.$store.state.noDB = true;
              this.show2 = true;
            }
          });
      }

      db.collection("shops")
        .where("owner", "==", firebase.auth().currentUser.uid)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              shoptype: doc.data().shoptype,
              categories: doc.data().categories,
              name: doc.data().name,
              plan: doc.data().plan,
              shopcat: doc.data().cat,
              config: doc.data().config,
            };
            this.shops.push(data);
            this.plan = this.shops[0].plan;
            if (this.shops[0].shopcat == "Vehicles") {
              this.shopcategory = this.shops[0].shopcat;
            }

            //console.log(this.shops[0].id)
            //console.log(this.shops[0].categories)
          });
          this.$store.state.secondaryDatabase
            .collection("shops")
            .where("owner", "==", firebase.auth().currentUser.uid)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                const data = {
                  id: doc.id,
                  categories: doc.data().categories,
                  cat: doc.data().cat
                };

                this.shopcategory = data.cat
                this.secondaryDBshop.push(data);
                this.shopcats = this.secondaryDBshop[0].categories;
                this.$store.state.categories = this.shopcats;
              });
            })
            .catch((error) => alert(error.message));
          const docRef = this.$store.state.secondaryDatabase.collection("stores");
          let firestoreQuery = docRef;
          if(this.$store.state.noDB === true) {
            firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
          }
          firestoreQuery
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                const data = {
                  id: doc.id,
                  value: doc.id,
                  label: doc.data().name,
                  text: doc.data().name,
                  name: doc.data().name,
                  logo: doc.data().logo,
                  email: doc.data().email,
                  city: doc.data().city,
                  address: doc.data().address,
                  telephone: doc.data().telephone,
                  netPay: doc.data().netPay,
                  invo: doc.data().invo,
                  totalProfit: doc.data().totalProfit,
                  totalRemain: doc.data().totalRemain,
                  PORemain: doc.data().PORemain,
                  POTotal: doc.data().POTotal,
                  POs: doc.data().POs,
                  totalExp: doc.data().totalExp,
                  setting: doc.data().setting,
                };
                console.log("this.sysadmin", this.sysadmin);
                this.stores.push(data);
              });
              this.$store.state.stores = this.stores;
            })
            .catch((error) => alert(error.message));
          let prds = 'prds';
          if(this.$store.state.noDB === true) {
            prds = `prds${firebase.auth().currentUser.uid}`
          }
          this.$store.state.secondaryDatabase
            .collection("prdlist")
            .doc(prds)
            .get()
            .then((doc) => {
              if (doc.exists) {
                const bytes = sizeof(doc.data());
                console.log("size of doc", bytes);
                this.$store.state.prdNameList = doc.data().data;
              } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
              }
            })
            .catch((error) => {
              console.log("Error getting document:", error);
            });

          this.loading = false;
          this.fetch = true;
        })
        .then(() => {
          //console.log('this.notices')
          db.collection("shops")
            .doc(this.shops[0].id)
            .collection("notify")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                const notice = {
                  title: doc.data().notice.title,
                  msg: doc.data().notice.msg,
                };
                this.notices.push(notice);
                //console.log(this.notices)
              });
            });
        });
    }
  },
};
</script>

<style scoped>
@import url("~@/assets/main/css/loading.css");

.item {
  margin-top: -10px !important;
  margin-right: 20px;
}

.el-menu-item {
  height: 42px;
  line-height: 42px;
}

.el-menu-item i {
  color: #cdd3df;
}

.el-submenu__title i {
  color: #cdd3df;
}

.el-header {
  color: #fff;
  line-height: 60px;
  overflow: hidden;
  position: fixed;
  top: 0px;
  z-index: 1002;
}

#elaside::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#elaside::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

#elaside::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

.el-aside {
  color: #fff;
  max-height: 100vh;
  overflow: hidden;
  overflow-y: scroll;
  position: fixed;
}

.el-footer {
  /* position: fixed; */
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  z-index: 1002;
}

.searchbar .field-input {
  text-align: center;
  margin: 16px 0;
}

.searchbar .field-input input {
  text-align: left;
  border-radius: 6rem;
  border: 1px solid #a0a0a0;
  background-color: transparent;
  color: #faf7f7;
  padding: 0.4rem 2rem 0.4rem 1rem;
  width: 14rem;
  transition: 0.5s;
}

.searchbar .field-input input:focus {
  outline: none;
  border-color: #faf7f7;
  transition: 0.5s;
  color: rgb(240, 243, 247);
}

.searchbar .field-input span:before {
  content: "";
  cursor: pointer;
  position: relative;
  font-family: "fontawesome";
  top: 0;
  right: 1.5rem;
}

.header-notification .bell-icon .notification-list {
  width: 240px !important;
  padding-left: 0px !important;
  list-style-type: none;
  text-align: center;
  background-color: #fffbfb;
  border-radius: 7px;
  -webkit-animation: fadeIn 1s;
  animation: fadeIn 1s;
}

.header-notification .bell-icon .notification-list-name {
  background: #fff;
  color: #9bb7c5;
  padding: 10px 0;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  border-bottom: 1px solid #9bb7c5;
  transition: all 1s ease-in-out;
}

.header-notification .bell-icon .notification-list .large-number {
  font-size: 0.8em;
  border-width: 5px;
}

.header-notification .bell-icon .list-item {
  border-bottom: 1px solid #9bb7c5;
  transition: all 1s ease-in-out;
}

.header-notification .bell-icon .list-item .user-image {
  width: 40px;
  height: 40px;
  border-radius: 50px;
}

.header-notification .bell-icon .list-item .messages {
  padding-left: 10px;
  color: #909da8;
}

.header-notification .bell-icon .list-item .messages b {
  color: #727f8c;
}

.header-notification .bell-icon .list-item--link {
  display: flex;
  padding: 10px;
  text-decoration: none;
  text-align: left;
  font-size: 0.7em;
  opacity: 0.8;
  align-items: center;
}

.header-notification .bell-icon .list-item--link:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminView.vue